import { COMSDOMAIN } from '../environment';

export const apiPrefix = COMSDOMAIN;
export default {
  apiGateway: {
    comsHealthCheck: `${apiPrefix}/healthcheck`,
    getUserById: `${apiPrefix}/dice/getUserById`,
    createOrGetUser: `${apiPrefix}/dice/createOrGetUser`,
    fetchGroupsForUser: `${apiPrefix}/dice/getGroupsForUser`,
    createGroup: `${apiPrefix}/dice/createGroup`,
    fetchIncidents: `${apiPrefix}/dice/getIncidentsForUser`,
    fetchIncidentStatus: `${apiPrefix}/dice/getIncidentStatus`,
    inviteGroupMember: `${apiPrefix}/dice/inviteToGroup`,
    createIncident: `${apiPrefix}/dice/createIncident`,
    updateIncidentGroup: `${apiPrefix}/dice/updateIncidentGroup`,
    sendNotificationByGroup: `${apiPrefix}/dice/notifications/sendNotificationByGroup`,
    fetchNotificationsByGroup: `${apiPrefix}/dice/notifications/fetchNotificationsByGroup`,
    deleteNotification: `${apiPrefix}/dice/notifications/deleteNotification`,
    fetchAllNotificationLogSummaries: `${apiPrefix}/dice/notifications/fetchAllNotificationLogSummaries`,
    upsertNotification: `${apiPrefix}/dice/notifications/upsertNotification`,
    getRosterForIncident: `${apiPrefix}/dice/incident/getRosterForIncident`,
    getDraftRosterMembersForIncident: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/draft/members`,
    createDraftRoster: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/draft`,
    resolveOperationalPeriodFromAndTo: `${apiPrefix}/dice/incident/resolveOperationalPeriodFromAndTo`,
    incidentPositions: `${apiPrefix}/dice/incident/incidentPositions`,
    incidentPositionAndRole: `${apiPrefix}/dice/incident/incidentPositionAndRole`,
    updateMemberActivation: `${apiPrefix}/dice/incident/updateMemberActivation`,
    fetchAllOrgScopedRolesInGroup: `${apiPrefix}/dice/roles/allOrgScopedRolesForGroup`,
    fetchAllRoleAssignmentsInGroup: `${apiPrefix}/dice/roles/allRolesPerUserInGroup`,
    createRole: `${apiPrefix}/dice/roles/createRoleWithPermissions`,
    editRole: `${apiPrefix}/dice/roles/editRoleAndPermissions`,
    deleteRole: `${apiPrefix}/dice/roles/deleteRole`,
    assignRole: `${apiPrefix}/dice/roles/assignUserToRole`,
    unassignRole: `${apiPrefix}/dice/roles/unAssignUserFromRole`,
    fetchRostersForGroups: `${apiPrefix}/dice/roles/fetchRostersForGroups`,
    fetchAllPermissions: `${apiPrefix}/dice/roles/permissions`,
    fetchAllPermissionsInRole: `${apiPrefix}/dice/roles/getPermissionsForRole`,
    editGroup: `${apiPrefix}/dice/editgroup`,
    validateRBACPermissionForAction: `${apiPrefix}/dice/validations/validateRBACPermissionForAction`,
    removeUserFromGroup: `${apiPrefix}/dice/removeUserFromGroup`,
    deleteGroup: `${apiPrefix}/dice/deleteGroup`,
    updateCurrentlySelected: `${apiPrefix}/dice/updateCurrentlySelected`,
    exportFormToPDF: `${apiPrefix}/dice/forms/exportFormToPDF`,
    fetchIncidentsForGroup: `${apiPrefix}/dice/fetchIncidentsForGroup`,
    updateUserProfileSettings: `${apiPrefix}/dice/users/updateUserProfileSettings`,
    updateHomeAor: `${apiPrefix}/dice/users/updateHomeAor`,
    bulkUserImport: `${apiPrefix}/dice/bulkUserImport`,
    setCloneDefaults: `${apiPrefix}/dice/setCloneDefaults`,
    fetchCloneDefaults: `${apiPrefix}/dice/fetchCloneDefaults`,
    tileServerProxy: `${apiPrefix}/tiles`,
    fetchNotificationLog: `${apiPrefix}/dice/notifications/fetchNotificationLog`,
    fetchNotificationCount: `${apiPrefix}/dice/notifications/fetchNotificationCount`,
    fetchNotificationLogInstance: `${apiPrefix}/dice/notifications/fetchNotificationLogInstance`,
    toggleAllowAdminProfileEdit: `${apiPrefix}/dice/users/toggleAllowAdminProfileEdit`,
    fetchUserGroupsRolesIncidents: `${apiPrefix}/dice/groups/fetchUserGroupsRolesIncidents`,
    createDistributionList: `${apiPrefix}/dice/distribution-list/createDistributionList`,
    fetchDistributionListByGroup: `${apiPrefix}/dice/distribution-list/fetchDistributionListByGroup`,
    deleteDistributionList: `${apiPrefix}/dice/distribution-list/deleteDistributionList`,
    removeMembersFromDistributionList: `${apiPrefix}/dice/distribution-list/removeMembersFromDistributionList`,

    addMemberToIncidentRoster: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/addMembers`,
    removeMemberFromIncidentRoster: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/removeMember`,
    removeSelfFromRoster: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/removeSelfFromRoster`,
    assignMemberToPositionInRoster: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/assignMemberToPosition`,
    removeMemberFromPositionInRoster: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/removeMemberFromPosition`,
    updatePositionAssignment: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/updatePositionAssignment`,
    assignExternalUser: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/assignExternalUser`,
    updateMemberPositionsInRoster: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/updateMemberPositions`,
    rosterResources: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/resources`,
    rosterResourceOptions: (incidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/resource-options`,
    rosterResource: (incidentId: string, resourceInIncidentId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/roster/resources/${resourceInIncidentId}`,
    addNonMemberToIncident: `${apiPrefix}/dice/incident/createIncidentNonMembers`,
    markIncidentMemberActive: `${apiPrefix}/dice/incident/markIncidentMemberActive`,
    markIncidentMemberDeactive: `${apiPrefix}/dice/incident/markIncidentMemberDeactive`,
    addScheduleToIncident: `${apiPrefix}/dice/incident/addScheduleToIncident`,
    getAllUserScheduleToIncident: `${apiPrefix}/dice/incident/getAllUserScheduleToIncident`,
    deleteScheduleToIncident: `${apiPrefix}/dice/incident/deleteScheduleToIncident`,
    toggleApprovalAuthority: `${apiPrefix}/dice/incident/toggleApprovalAuthority`,
    upsertOperationalPeriod: `${apiPrefix}/dice/incident/upsertOperationalPeriod`,
    advanceOperationalPeriod: `${apiPrefix}/dice/incident/advanceOperationalPeriod`,
    escalateIncident: `${apiPrefix}/dice/incident/escalateIncident`,
    updateCurrentOperationalPeriod: `${apiPrefix}/dice/incident/updateCurrentOperationalPeriod`,
    getCurrentPeriod: (incidentId: string) =>
      `${apiPrefix}/dice/incident/getCurrentPeriod/${incidentId}`,
    getFuturePeriod: (incidentId: string) =>
      `${apiPrefix}/dice/incident/getFuturePeriod/${incidentId}`,
    getAllUserSchedule: `${apiPrefix}/dice/user/getAllUserSchedule`,
    addUserSchedule: `${apiPrefix}/dice/user/addUserSchedule`,
    deleteUserSchedule: `${apiPrefix}/dice/user/deleteUserSchedule`,
    fileDownloadUrl: `${apiPrefix}/dice/files/signed-urls/download`,
    trackUserLogin: `${apiPrefix}/dice/tracking/trackUserLogin`,
    getEnvironmentVariables: `${apiPrefix}/dice/getEnvironmentVariables`,
    getAllWorkspace: `${apiPrefix}/dice/groups/getAllWorkspace`,
    upsertBranch: `${apiPrefix}/dice/forms/ics/planning_worksheet/upsertBranch`,
    deleteBranch: `${apiPrefix}/dice/forms/ics/planning_worksheet/deleteBranch`,
    upsertDivision: `${apiPrefix}/dice/forms/ics/planning_worksheet/upsertDivision`,
    deleteDivision: `${apiPrefix}/dice/forms/ics/planning_worksheet/deleteDivision`,
    getAllBranch: `${apiPrefix}/dice/forms/ics/planning_worksheet/getAllBranch`,
    getAllDivision: `${apiPrefix}/dice/forms/ics/planning_worksheet/getAllDivision`,
    getAllDivisionByGroupId: `${apiPrefix}/dice/forms/ics/planning_worksheet/getAllDivisionByGroupId`,
    testAlertEmail: `${apiPrefix}/dice/alerts/geolocationsAtRiskReport`,
    upsertAor: `${apiPrefix}/dice/groups/location/upsertAOR`,
    getAllAor: `${apiPrefix}/dice/groups/location/getAllAOR`,
    deleteAor: `${apiPrefix}/dice/groups/location/deleteAOR`,
    getAorsByHierarchy: (groupGuid: string) =>
      `${apiPrefix}/dice/groups/location/aors-by-hierarchy/${groupGuid}`,
    getAorDescendants: (groupGuid: string, aorId: string) =>
      `${apiPrefix}/dice/groups/location/aor-descendants/${groupGuid}/${aorId}`,
    createAorsFromGeojson: (groupGuid: string) =>
      `${apiPrefix}/dice/groups/location/geojson-import/${groupGuid}`,
    getOpfacsForGroup: (groupGuid: string) =>
      `${apiPrefix}/dice/groups/opfac/${groupGuid}`,
    createOpfacsFromFile: (groupGuid: string) =>
      `${apiPrefix}/dice/groups/opfac/opfac-import/${groupGuid}`,
    importAlmisDataFromFile: (groupId: string) =>
      `${apiPrefix}/dice/almis/almis-test-import/${groupId}`,
    getAllUserWorkspace: `${apiPrefix}/dice/groups/getAllUserWorkspace`,
    fetchTaskList: `${apiPrefix}/dice/taskmanagement/searchTask`,
    saveTask: `${apiPrefix}/dice/taskmanagement/saveTask`,
    generateTeamSite: `${apiPrefix}/dice/teams/createTeams`,
    customTeamTemplates: `${apiPrefix}/dice/teams/customTeamTemplates`,
    customTeamSites: `${apiPrefix}/dice/teams/customTeamSites`,
    uploadFileToTeams: `${apiPrefix}/dice/teams/uploadFileToTeams`,
    shareFileWithTeams: `${apiPrefix}/dice/teams/shareFileWithTeams`,
    addTaskComment: `${apiPrefix}/dice/taskmanagement/upsertCommentForTask`,
    getAllTaskComments: `${apiPrefix}/dice/taskmanagement/getAllCommentForTask`,
    getAllTaskLogs: `${apiPrefix}/dice/taskmanagement/getAllLogsTask`,
    getAllTaskUnits: `${apiPrefix}/dice/taskmanagement/getAllTaskUnits`,
    upsertTaskUnit: `${apiPrefix}/dice/taskmanagement/upsertTaskUnit`,
    deleteTaskUnit: `${apiPrefix}/dice/taskmanagement/deleteTaskUnit`,
    teamTemplateIds: `${apiPrefix}/dice/teams/templateIds`,
    teamsCapabilities: `${apiPrefix}/dice/teams/capabilities`,
    teamsConsentCheck: `${apiPrefix}/dice/teams/consentCheck`,
    addMemberToTeams: `${apiPrefix}/dice/teams/addMemberToTeams`,
    removeMemberFromTeams: `${apiPrefix}/dice/teams/removeMemberFromTeams`,
    checkTeamsStatus: `${apiPrefix}/dice/teams/checkTeamsStatus`,
    teamConnectionStatus: `${apiPrefix}/dice/teams/teamConnectionStatus`,
    connectExistingTeam: `${apiPrefix}/dice/teams/connectExistingTeam`,
    disconnectExistingTeam: `${apiPrefix}/dice/teams/disconnectExistingTeam`,
    getGroupFromIncidentId: `${apiPrefix}/dice/incident/getGroupFromIncidentId`,
    fetchAIEventAnalysis: `${apiPrefix}/dice/dgpt/fetchAIEventAnalysis`,
    storeSsoToken: `${apiPrefix}/dice/teams/storeSsoToken`,

    // AI
    exportAsForm: `${apiPrefix}/dice/forms/exportAsForm`,
    exportPaginatedIAP: `${apiPrefix}/dice/forms/exportPaginatedIAP`,
    persistIcsFormExport: `${apiPrefix}/dice/forms/persistIcsFormExport`,
    fetchGroupAIUsage: `${apiPrefix}/dice/dgpt/fetchGroupAIUsage`,
    fetchAllGroupsAIUsage: `${apiPrefix}/dice/dgpt/fetchAllGroupsAIUsage`,
    disasterchat: `${apiPrefix}/dice/dgpt/disasterchat`,
    aiCatalog: `${apiPrefix}/dice/dgpt/ai/catalog`,
    sitrepTemplates: `${apiPrefix}/dice/dgpt/sitreps/templates`,
    sitrepSectionTemplates: `${apiPrefix}/dice/dgpt/sitreps/section-templates`,
    sitrepsV2: `${apiPrefix}/dice/dgpt/sitreps_v2`,
    sitrepEligibleReviewers: (sitrepId: string) =>
      `${apiPrefix}/dice/dgpt/sitreps_v2/${sitrepId}/eligibleReviewers`,
    attachFilesToSitrep: `${apiPrefix}/dice/dgpt/sitreps_v2/attachFiles`,
    detachFileFromSitrep: `${apiPrefix}/dice/dgpt/sitreps_v2/detachFile`,
    sitrepImages: (sitrepId: string) =>
      `${apiPrefix}/dice/dgpt/sitreps_v2/${sitrepId}/image`,
    sitrepSectionImages: (sectionId: string) =>
      `${apiPrefix}/dice/dgpt/sitreps_v2/section/${sectionId}/image`,
    getSitrepAttachedFiles: (sitrepId: string) =>
      `${apiPrefix}/dice/dgpt/sitreps_v2/${sitrepId}/attachedFiles`,
    customDataSources: `${apiPrefix}/dice/dgpt/custom-data-sources`,
    dgptAlerts: `${apiPrefix}/dice/dgpt_alerts`,
    dgptAlertsGenerateCategories: `${apiPrefix}/dice/dgpt_alerts/generateCategories`,

    // ICS
    ics_incident: `${apiPrefix}/dice/ics/incident`,
    ics_incidents: `${apiPrefix}/dice/ics/incidents`,
    activityLogsIncident: (incidentId: string) =>
      `${apiPrefix}/dice/activity-logs/${incidentId}`,
    activityLogsSummary: (incidentId: string) =>
      `${apiPrefix}/dice/activity-logs/${incidentId}/summary`,
    activityLogsDetail: (incidentId: string, logDate: string) =>
      `${apiPrefix}/dice/activity-logs/${incidentId}/${logDate}`,
    activityLogsEntries: (incidentId: string, logDate: string) =>
      `${apiPrefix}/dice/activity-logs/${incidentId}/${logDate}/entries`,
    activityLogsEntry: (incidentId: string, logDate: string, entryId: string) =>
      `${apiPrefix}/dice/activity-logs/${incidentId}/${logDate}/entries/${entryId}`,
    activityLogsSubmit: (incidentId: string, logDate: string) =>
      `${apiPrefix}/dice/activity-logs/${incidentId}/${logDate}/submit`,
    activityLogsPreview: (incidentId: string, logDate: string) =>
      `${apiPrefix}/dice/activity-logs/${incidentId}/${logDate}/preview`,
    operational_periods: `${apiPrefix}/dice/incident/operational_periods`,
    ics_incident_info: `${apiPrefix}/dice/ics/incident_info`,
    ics_map_sketch: `${apiPrefix}/dice/ics/map_sketch`,
    ics_objectives: `${apiPrefix}/dice/ics/objectives`,
    ics_incident_objectives: `${apiPrefix}/dice/ics/objectives/incident`,
    ics_incident_areas: `${apiPrefix}/dice/ics/areas`,
    ics_incident_agencies: `${apiPrefix}/dice/ics/agencies`,
    ics_incident_organization_assignments: `${apiPrefix}/dice/ics/icsIncidentOrganizationAssignments`,
    ics_incident_divisions: `${apiPrefix}/dice/ics/divisions`,
    ics_incident_branches: `${apiPrefix}/dice/ics/branches`,
    ics_strategies: `${apiPrefix}/dice/ics/strategies`,
    ics_incident_strategies: `${apiPrefix}/dice/ics/strategies/incident`,
    ics_tactics: `${apiPrefix}/dice/ics/tactics`,
    ics_incident_tactics: `${apiPrefix}/dice/ics/tactics/incident`,
    ics_actions: `${apiPrefix}/dice/ics/actions`,
    ics_incident_actions: `${apiPrefix}/dice/ics/actions/incident`,
    ics_org_actions: `${apiPrefix}/dice/ics/actions/org`,
    ics_incident_calendar_events: `${apiPrefix}/dice/ics/calendar/incident`,
    ics_medical_aid_stations: `${apiPrefix}/dice/ics/medical_aid_stations`,
    ics_incident_medical_aid_stations: `${apiPrefix}/dice/ics/medical_aid_stations/incident`,
    ics_medical_transportation: `${apiPrefix}/dice/ics/medical_transportation`,
    ics_incident_medical_transportation: `${apiPrefix}/dice/ics/medical_transportation/incident`,
    ics_hospitals: `${apiPrefix}/dice/ics/hospitals`,
    ics_incident_hospitals: `${apiPrefix}/dice/ics/hospitals/incident`,
    ics_work_assignments: `${apiPrefix}/dice/ics/work_assignments/incident`,
    ics_work_assignment_list_attachment: `${apiPrefix}/dice/ics/work_assignment_list_attachment/incident`,
    ics_planned_resource: `${apiPrefix}/dice/ics/planned_resource`,
    ics_coms: `${apiPrefix}/dice/ics/coms`,
    ics_incident_coms: `${apiPrefix}/dice/ics/coms/incident`,
    ics_coms_list: `${apiPrefix}/dice/ics/coms_list`,
    ics_incident_coms_list: `${apiPrefix}/dice/ics/coms_list/incident`,
    ics_incident_resources: `${apiPrefix}/dice/ics/resources/incident`,
    ics_resource_requests: `${apiPrefix}/dice/ics/resource_requests`,
    ics_resource_request_items: `${apiPrefix}/dice/ics/resource_request_items`,
    ics_resource_sets: `${apiPrefix}/dice/ics/resource_sets`,
    ics_resource_sets_paginated: `${apiPrefix}/dice/ics/resource_sets_paginated`,
    ics_resource_sites: `${apiPrefix}/dice/ics/resource_sites`,
    ics_booms: `${apiPrefix}/dice/ics/booms`,
    ics_locations: `${apiPrefix}/dice/ics/locations`,
    ics_strike_teams: `${apiPrefix}/dice/ics/strike_teams`,
    ics_custom_resource_types: `${apiPrefix}/dice/ics/custom_resources`,
    ics_custom_resource_types_v2: `${apiPrefix}/dice/ics/custom_resources_site_types`,
    ics_bulk_resources: `${apiPrefix}/dice/ics/bulkResources`,
    ics_safety_messages: `${apiPrefix}/dice/ics/safety_messages`,
    ics_incident_status_summary: `${apiPrefix}/dice/ics/incident_status_summary`,
    ics_hazmats: `${apiPrefix}/dice/ics/hazmats`,
    icsResourceInIncident: `${apiPrefix}/dice/ics/ics_resource_in_incident`,

    incidentMemberWorkLogs: (incidentId: string, userId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/users/${userId}/work-logs`,

    incidentMemberStatus: (incidentId: string, userId: string) =>
      `${apiPrefix}/dice/incident/${incidentId}/users/${userId}/status`,

    incident: `${apiPrefix}/dice/incident`,

    redisHealthCheck: `${apiPrefix}/dice/notification/redisHealthCheck`,
    notification_jobs: `${apiPrefix}/dice/notification/jobs`,
    customEvents: `${apiPrefix}/dice/custom-events`,
    sitrep_export_pdf: `${apiPrefix}/dice/dgpt/sitreps_v2/export-pdf`,
    sharepoint_upload: `${apiPrefix}/dice/dgpt/sharepoint_upload`,

    // SSE Streams
    notificationStream: `${apiPrefix}/dice/notifications/stream`,
    eventsStream: `${apiPrefix}/events/stream`,
    dgptStream: `${apiPrefix}/dgpt/stream`,

    // Organization Subscription
    createOrgSubscription: `${apiPrefix}/subscription/createSubscription`,
    updateOrgSubscription: `${apiPrefix}/subscription/updateSubscription`,

    externalMaps: `${apiPrefix}/dice/dgpt/external-maps`,

    // Data layers
    external_layers: `${apiPrefix}/dice/external_layers`,
    internal_layers: `${apiPrefix}/dice/internal_layers`,
    internal_layer_versions: `${apiPrefix}/dice/internal_layer_versions`,
    layer_nodes: `${apiPrefix}/dice/layer_nodes`,

    // Airport Codes
    initialCodes: `${apiPrefix}/dice/etl/importInitialIataCodes`,
    airportCodes: `${apiPrefix}/dice/etl/importAirportsFromIataCodes`,

    // Airports data
    fetchAirports: `${apiPrefix}/dice/transportation/fetchAirports`,
    fetchSeaports: `${apiPrefix}/dice/transportation/fetchSeaports`,
    fetchAirportsCount: `${apiPrefix}/dice/transportation/fetchAirportsCount`,
    fetchSeaportsCount: `${apiPrefix}/dice/transportation/fetchSeaportsCount`,

    // Airport schedule data
    importAirportDepartures: `${apiPrefix}/dice/etlAirportScheduler/importAirportDepartures`,
    importAirportArrivals: `${apiPrefix}/dice/etlAirportScheduler/importAirportArrivals`,
    checkTransportationCapacity: `${apiPrefix}/dice/transportation/checkCapacity`,
    getCapacityAnalysisList: `${apiPrefix}/dice/transportation/getCapacityAnalysisList`,
    getCapacityAnalysis: `${apiPrefix}/dice/transportation/getCapacityAnalysis`,

    // Air Assets
    importAirAssests: `${apiPrefix}/dice/etlAirAsset/importAirAssets`,

    //Utility Impact Prediction
    getFullServiceTerritories: `${apiPrefix}/dice/utility/fullServiceTerritories`,
    getTimeSeriesData: `${apiPrefix}/dice/utility/timeSeries`,
    getLatestDate: `${apiPrefix}/dice/utility/date`,
    getAllDistricts: `${apiPrefix}/dice/utility/districts`,
    getGeoJSONs: `${apiPrefix}/dice/utility/geojsons`,

    // Organization Subscription
    getAllOrganizations: `${apiPrefix}/dice/organizations`,
    updateOrganization: `${apiPrefix}/dice/organizations`,

    filesBase: `${apiPrefix}/dice/files`,
    foldersBase: `${apiPrefix}/dice/files/folders`,

    // Notifications
    sendPratusAlert: `${apiPrefix}/dice/pratusAlerts/sendPratusAlert`,
    notifications: `${apiPrefix}/dice/notifications`,

    //Approvals
    approvals: `${apiPrefix}/dice/approvals`,

    // User Notifications
    userNotifications: `${apiPrefix}/dice/user-notifications`,

    // Incidents
    incidents: `${apiPrefix}/dice/v1_incidents`,

    // External Users and Organizations
    externalUsers: `${apiPrefix}/dice/externalUsers`,
    doesEmailBelongToExistingUser: `${apiPrefix}/dice/externalUsers/doesEmailBelongToExistingUser`,
  },
  apiPrefix,
} as const;
